export default __webpack_public_path__ + "static/media/GoodMannersInARestaurant_07.79409944.png";